import type { TransitionProps } from 'vue'
import type { RouteLocationNormalizedGeneric } from 'vue-router'

export type TransitionFn = (from: RouteLocationNormalizedGeneric, to: RouteLocationNormalizedGeneric) => TransitionProps

/* eslint-disable no-console */
export function transitionLog(...args: any) {
  if (import.meta.dev) {
    console.info('\x1B[46m TRANSITION \x1B[0m', ...args)
  }
}

export default defineNuxtRouteMiddleware((to, from) => {
  const fromRouteName: string = String(from.meta.templateName) || ''
  const toRouteName: string = String(to.meta.templateName) || ''

  if (import.meta.dev) {
    transitionLog(`Transition: ${fromRouteName}, ${toRouteName}`)
  }

  const transition = getDefaultPageTransition(from, to)

  if (to.meta.overlay || from.meta.overlay) {
    return
  }

  to.meta.pageTransition = transition
  from.meta.pageTransition = transition
})
